module.exports = __webpack_public_path__ + "static/media/react-logo.2561c854.svg";